export const Action_User_Types ={
    SAVE_USER:"SAVE_USER",
    SAVE_MANAGER:"SAVE_MANAGER",
    CURRENT_CONTROL:"CURRENT_CONTROL"
}


export const save_user = (user) => ({
    type: Action_User_Types.SAVE_USER,
    user
})

export const save_manager = (manager) => ({
    type: Action_User_Types.SAVE_MANAGER,
    manager
})

export const current_control = (control) => ({
    type: Action_User_Types.CURRENT_CONTROL,
    control
})



